import JoinDoneComponent from './join-done.vue'
export default JoinDoneComponent
